import { render, staticRenderFns } from "./ContactsInfo.vue?vue&type=template&id=407232f2&scoped=true"
import script from "./ContactsInfo.vue?vue&type=script&lang=js"
export * from "./ContactsInfo.vue?vue&type=script&lang=js"
import style0 from "./ContactsInfo.vue?vue&type=style&index=0&id=407232f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407232f2",
  null
  
)

export default component.exports